import EmployersList from './EmployersListContainer';
export default EmployersList;



// WEBPACK FOOTER //
// ./src/components/Profile/EmployersList/index.js